<template>
  <div>
    <ins-header
      :title="headerTitle"
      @back="goBack"
      hasVerifi="true"
      @next="conferm"
    ></ins-header>
    <div class="transac-amount">{{ formatPrice(amount) }}</div>
    <p class="color-w" style="margin-bottom: 12px">ریال</p>
    <div
      class="overflow-hidden flex items-center justify-center inside-card dir-rtl"
    >
      <div class="send">
        <div class="chose-destiny">
          <p>به</p>
          <input
            class="destni-input"
            v-model="destination"
            placeholder="حساب، شماره تلفن، ایمیل"
            @keyup.enter="searchUser"
            @keyup="searchUser"
          />
        </div>
        <input
          style="width: 94%"
          v-model="description"
          placeholder="انتقال بابت"
        />
        <p style="margin-top: 18px">موارد اخیر</p>
        <div class="finde-number">
          <div
            v-if="destinationUser == null && destinationUser == null"
            style="margin: 17%"
          >
            <p>هیچ شخصی یافت نشد.</p>
          </div>
          <div v-else class="destination">
            <img :src="avatar" />
            <p>
              {{ destinationUser.first_name }} {{ destinationUser.last_name }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InsHeader from "../../layouts/inside-header.vue";
export default {
  props: {
    data: [],
  },
  computed: {
    headerTitle() {
      return this.$route.meta.prtitle;
    },
  },
  data() {
    return {
      amount: 0,
      destination: null,
      description: null,
      destinationUser: null,
      avatar: null,
    };
  },
  beforeMount() {
    this.amount = this.$route.params.amount;
  },
  methods: {
    goBack() {
      this.$router.back();
    },
    searchUser() {
      setTimeout(() => {
        var data = {
          keyword: this.destination,
        };
        this.$store.dispatch("transaction/findUser", data).then((rsp) => {
          this.destinationUser = rsp;
          this.avatar = "https://media-dev.bfst.ir/" + rsp.avatar;
        });
      }, 1500);
    },
    conferm() {
      this.$store.commit("transaction/setDescription", this.description);
      this.$store.commit("transaction/setAmount", this.amount);
      this.$store.commit(
        "transaction/setDistinationUser",
        this.destinationUser
      );
      this.$router.push({ name: "Confirmation" });
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace(".", ",");
      return val.toLocaleString("fa-IR").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
  },
  components: {
    InsHeader,
  },
};
</script>
<style scoped>
P {
  font-size: 12px;
}
</style>
